import React from "react"

export const appStoreUrl = `https://apps.apple.com/app/id1517617435`
export const appTitle = `Birthday Countdown & Reminders`
export const appSubtitle = 'Calendar. List. Timer. Widget'
export const appPromo = <div style={{ textAlign: "left" }}>
Never forget a birthday again!<br />
• Customize your reminders<br />
• Reminds to buy a present<br />
• Sync with contacts and calendar<br />
• No subscriptions!<br />
• Unlimited events & reminders<br />
• Celebrate birthdays and anniversaries<br />
• Arrange your contacts into groups and customize their appearance and reminders!<br />
• Count down to the event in days, months, hours, you name it!
</div>
